import React, { Fragment } from "react";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import Noc from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import { useQueryClient } from "react-query";
import { getRscObject } from "helpers/rsc";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


function useGetData(apparatus) {
    const { mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    const rscObj = getRscObject(mirs_rsc)

    let event = "1AP" + apparatus + "-------------";
    let rsc = rscObj.discipline + rscObj.sex + event + "QUAL";

    let query = ['resultsApparatusQual', mirs_competition, rsc, mirs_language]
    const queryClient = useQueryClient();
    const data = queryClient.getQueryData(query);

    return data
}

const GarCurrent = ({ data, apparatus }) => {


    //get data from qualification

    const dataQual = useGetData(apparatus);

    const { breakPoint } = useViewport();
    const currents = data?.results?.items?.filter(
        item => item?.extendedResultsCurrent?.length > 0 &&
            item.extendedResultsCurrent?.find(extCurrtentItem =>
                extCurrtentItem.er_code === 'STAGE' &&
                extCurrtentItem.er_type === 'ER' &&
                (extCurrtentItem.er_value === "CURRENT" || extCurrtentItem.er_value === "WAITING")
            ))
    let ret = currents.map((item, key) => {
        const extendedResultsCurrent = ((item?.extendedResultsCurrent && item.extendedResultsCurrent.length > 0))
            ? item.extendedResultsCurrent
            : undefined


        /*
            const posFirtsColumn = findArray(extendedResultsCurrent, { er_type: ['ER'], er_code: ['SCORE'], er_pos: [1] }) ? true : false;
        let score = findArray(extendedResultsCurrent, { er_type: ['ER'], er_code: ['SCORE'], ...(posFirtsColumn && { er_pos: ["1"] }) })?.er_value
        const scoreValue = (item.resultType === 'IRM')
            ? item?.resultIrm
            : item.resultData
        //: item.resultData ? item.resultData : score;
        */


        //item.participant.code
        let athQualData = Array.isArray(dataQual?.phaseResults) && dataQual?.phaseResults[0].items?.find(itemPhase => itemPhase.participant.code === item.participant.code);


        let _rank = athQualData?.resultRank;

        const _score = (athQualData?.resultType === 'IRM')
            ? athQualData?.resultIrm
            : athQualData?.resultData


        return (
            <Fragment key={`GarCurrent-${key}`}>
                <div><h6 className="text-dark"><Label data="HeaderCurrentCompetitor" /></h6></div>
                <div className="title d-flex flex-row">
                    <div className="d-flex align-items-center justify-content-end w-5 me-2"><Label data="HeaderBib" /></div>
                    <div className={"d-flex align-items-center justify-content-start  w-65 ms-2"}><Label data="HeaderName" /></div>
                    <div className="d-flex align-items-center justify-content-center w-30"><Label data="HeaderQualification" /></div>
                </div>

                <div className="d-flex flex-row border">
                    <div className="d-flex align-items-center justify-content-end w-5 me-2">{item?.bib}</div>
                    <div className={"d-flex align-items-center justify-content-start  w-65 ms-2"}>
                        <Noc className='me-1' {...item?.participant?.organisation} />
                        <Competitor
                            hidePicture={true}
                            nolink={true}
                            {...item.participant}
                        //guide={guide}
                        //showGuide={showGuide}
                        //disciplineClass={medicalClass}
                        />
                    </div>
                    <div className="d-flex flex-column w-30 justify-content-end me-2">
                        <div className="d-flex flex-row">
                            <div className="d-flex align-items-center justify-content-start w-70"><Label data="HeaderScore" /></div>
                            <div className="d-flex align-items-center justify-content-end w-30 me-2">{_score}</div>
                        </div>
                        <div className="d-flex flex-row">
                            <div className="d-flex align-items-center justify-content-start w-70"><Label data="HeaderRank" /></div>
                            <div className="d-flex align-items-center justify-content-end w-30 me-2">{_rank}</div>
                        </div>
                    </div>
                </div>
            </Fragment>)
    })


    return (
        <div className="mb-4">

            {ret}
        </div>


    );
}
export default GarCurrent;